import { createTheme, colors } from '@mui/material';
import shadows from './shadows';
import typography from './typography';
import BreakPoints from './breakPoints';

const theme = createTheme({
    breakpoints: {
        values: BreakPoints,
    },
    palette: {
         primary: {
            main: '#045A79',
            50:  '#E5F6FA',
            100: '#BFE9F3',
            200: '#93D8EA',
            300: '#57C0DA',
            400: '#2EA7C6',
            500: '#1588A6',
            600: '#0E6B89',
            700: '#0A516A',
            800: '#063B4D',
            900: '#042A37',
            950: '#02181F',
        },
        secondary: {
           main: '#FFB03D',
            50:  '#FFF7E8',
            100: '#FFEAC5',
            200: '#FFD38A',
            300: '#FFBB52',
            400: '#FFA630',
            500: '#FF941A',
            600: '#DB770F',
            700: '#B45A0C',
            800: '#8A430D',
            900: '#6B340C',
            950: '#3A1A05',
        },
        background: {
            dark: '#2F4858',
            gray: '#EBEBEB',
            gradient: 'linear-gradient(65.54deg, #FE7563 12.26%, #FE7663 20.52%, #FE9368 83.36%)',
            default: colors.common.white,
            paper: colors.common.white,
            green: '#98FFAF',
            red: '#FF8282',
        },
        borders: {
            green: '#81DF96',
            red: '#EB6969',
            gray: '#CFCFCF',
        },
        text: {
            main: '#FFF',
            primary: '#000',
            secondary: '#656565',
            // secondary: colors.blueGrey[600],
            black: 'black',
            darkGray: '#4D4D4D',
            bttnGray: '#575757',
            lightBlue: '#2C67DA',
            gray: '#666666',
            lightGray: '#BDBFD8',
            green: '#3C7129',
            red: '#E02B2F',
            white: '#FFFFFF',
            yellow: '#FC902D',
            orange: '#C1854D',
            textPrimary: '#FFF',
        },
    },
    shadows,
    typography,
});

export default theme;
